module.exports = {"id":"155862","name":"Sergio Ramos","rating":"90","photo":"./data/images/photos/1/155862.png","club":{"name":"Real Madrid","logo":"./data/images/clubs/RealMadrid.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergioRamos0.json
// module id = 3924
// module chunks = 0